import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { lineaInversionInfo } from 'src/app/home/_models/linea-inversion';


@Component({
  selector: 'app-select-linea-mobile',
  templateUrl: './select-linea-mobile.component.html',
  styleUrls: ['./select-linea-mobile.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
  ]
})

export class SelectLineaMobileComponent
{
  @Input() infoLineas: lineaInversionInfo[];
  @Input() infoLineaActiva: lineaInversionInfo;
  @Input() isRouteCnmv: boolean;
  @Output() seleccionarLineaMobile = new EventEmitter<string>();
  infoLineasParticipativas: lineaInversionInfo[] = [];
  infoLineasNoParticipativas: lineaInversionInfo[] = [];

  setLineaActiva(value: string)
  {
    this.seleccionarLineaMobile.emit(value);
  }

  ngOnInit(): void
  {
    if (this.infoLineas)
    {
      this.getInfoLineas();
    }
  }

  getInfoLineas(): void
  {
    this.infoLineas.forEach(linea =>
    {
      if (linea.ref === 'venture' || linea.ref === 'realestate' || linea.ref === 'creative')
      {
        this.infoLineasParticipativas.push(linea);
      } else
      {
        this.infoLineasNoParticipativas.push(linea);
      }
    });
  }
}
